/**
 * Обычный выпадающий список
 */
$.fn.simpleDropdown = function() {
    const $self = $(this);
    const $holder = $self.find('.js-value-holder');

    /**
     * Инициализация событий
     */
    const initEvents = () => {
        $holder.on('click', function () {
            $self.toggleClass('opened');
        })
    };

    /**
     * Инициализация плагина
     */
    const init = () => {
        initEvents();
    };

    init();

};
